import { render, staticRenderFns } from "./HistoricalUserFilter.vue?vue&type=template&id=b6ea3d34&scoped=true&"
import script from "./HistoricalUserFilter.vue?vue&type=script&lang=js&"
export * from "./HistoricalUserFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ea3d34",
  null
  
)

export default component.exports